import { Box, Grid, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorDetails } from "services/vendors";


export default function VendorInfo({vendorId}) {

  const { enqueueSnackbar } = useSnackbar();
  const [vendorDetails, setVendorDetails] = useState({});

  const getVendorInfo = useCallback((vendorId) => {
    getVendorDetails({}, {}, {vendorId}).then(({response, error}) => {
      if(response){
        setVendorDetails({...response});
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(vendorId){
      getVendorInfo(vendorId);
    }
  }, [vendorId, getVendorInfo]);
  
  return (
    <Box noValidate component="form"  sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={2} justifyContent="center">
        <Grid  item xs={12} sm={11} md={10} lg={10}>
          <TextField
            margin="normal"
            label="First Name"
            size="small"
            fullWidth
            defaultValue=""
            value={vendorDetails?.firstName || ''}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        <Grid  item xs={12} sm={11} md={10} lg={10}>
          <TextField
            margin="normal"
            label="Last Name"
            size="small"
            fullWidth
            defaultValue=""
            value={vendorDetails?.lastName || ''}
            inputProps={{
              readOnly: true
            }}
          />
        </Grid>

        <Grid item xs={12} sm={11} md={10} lg={10}>
          <TextField
            margin="normal"
            label="Mobile"
            size="small"
            fullWidth
            defaultValue=""
            value={vendorDetails?.mobile || ''}
            inputProps={{
              readOnly: true
            }}
          />
        </Grid>

        <Grid item xs={12} sm={11} md={10} lg={10}>
          <TextField
            margin="normal"
            label="Email"
            size="small"
            fullWidth
            defaultValue=""
            value={vendorDetails?.email || ''}
            inputProps={{
              readOnly: true
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
